import React from 'react';

type BrandTaglineProps = {
  className?: string;
};

/** Scoutly product tagline — shared across sidebar, drawer, and login shell. */
export default function BrandTagline({ className = 'brand-tag' }: BrandTaglineProps) {
  return (
    <span className={className} data-testid="brand-tagline">
      <span>Find.</span> <span>Monitor.</span>{' '}
      <span className="brand-accent">Act.</span>
    </span>
  );
}
